import type { ReactNode } from 'react';

export const symbol_car_fan_low_mid_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M564-55q-11 6-23 3t-18-14L419-242H145q-22 0-38.5-13.5T86-290L40-528q-9-43 19-77t72-34q32 0 57.5 20.5T223-566l62 223h111q16 0 30 8t22 22L575-96q6 11 3 23t-14 18ZM111-698q-29 0-50-21t-21-50q0-29 21-50t50-21q29 0 50 21t21 50q0 29-21 50t-50 21Zm435 155q-9 9-21 9t-21-9L356-691q-5-5-7-10t-2-11q0-6 2-11t7-10l148-148q9-9 21-9t21 9q9 9 9 21t-9 21l-96 96h239q13 0 21.5 8.5T719-713q0 13-8.5 21.5T689-683H449l97 98q8 9 8.5 21t-8.5 21Zm174 313q-5-2-10-7L562-385q-9-9-9-21.5t9-21.5q9-9 21-9t21 9l97 96v-238q0-13 8.5-21.5T731-600q13 0 21.5 8.5T761-570v239l96-96q9-9 21-9t21 9q9 9 9 21t-9 21L752-237q-5 5-10 7t-11 2q-6 0-11-2Z"
		/>
	</svg>
);
